import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUpload2Line = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M20 15.0001C20.5523 15.0001 21 15.4478 21 16.0001V20.0001C21 21.1047 20.1046 22.0001 19 22.0001H5C3.89543 22.0001 3 21.1047 3 20.0001V16.0001C3 15.4478 3.44772 15.0001 4 15.0001C4.55228 15.0001 5 15.4478 5 16.0001V20.0001H19V16.0001C19 15.4478 19.4477 15.0001 20 15.0001ZM12.8839 3.47451L16.9497 7.54038C17.3403 7.9309 17.3403 8.56407 16.9497 8.95459C16.5592 9.34511 15.9261 9.34511 15.5355 8.95459L13 6.41906V16.0001C13 16.5524 12.5523 17.0001 12 17.0001C11.4477 17.0001 11 16.5524 11 16.0001V6.41906L8.46447 8.95459C8.07394 9.34511 7.44078 9.34511 7.05025 8.95459C6.65973 8.56407 6.65973 7.9309 7.05025 7.54038L11.1161 3.47451C11.6043 2.98636 12.3957 2.98636 12.8839 3.47451Z" })
});
export default SvgUpload2Line;
